import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

type Props = {
  /** Signed-in users go back to the app; everyone else is sent to sign in. */
  signedIn: boolean;
};

export function NotFoundView({ signedIn }: Props) {
  const { t } = useTranslation();

  return (
    <main className="mx-auto grid max-w-md gap-6 p-6">
      <h1 className="font-heading font-bold text-2xl uppercase leading-tight tracking-[0.01em]">
        {t("Page not found")}
      </h1>

      <p className="text-muted-foreground text-sm">
        {t("The page you are looking for does not exist or was moved.")}
      </p>

      <Button asChild size="lg">
        {signedIn ? (
          <a href="/">{t("Back to home")}</a>
        ) : (
          <a href="/login">{t("Log in")}</a>
        )}
      </Button>
    </main>
  );
}
